<template>
  <div>
    <el-dialog v-model="unbindShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">解绑提示</div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="content">
          <div>
            解除绑定后，<span class="active_text">将无法使用该手机账号登录！</span>并且会丢失 选课记录
          </div>
          <div class="flex FlexjustifyEnd btn_box">
            <div class="btn_unbind">仍要解除绑定</div>
            <div class="btn_save mar_left_15">保留账号</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Unbind",

  data() {
    return {
      unbindShow: false,
    };
  },

  mounted() { },

  methods: {
    closePopup() {
      this.unbindShow = false;
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 486px;
  height: 270px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  .content {
    width: 100%;
    height: 480px;
    overflow: auto;
    font-size: 18px;
    color: #8e8e8e;
    padding: 20px;
    box-sizing: border-box;
    line-height: 36px;

    .active_text {
      color: RGBA(254, 39, 48, 1);
    }

    .btn_box {
      margin-top: 60px;

      .btn_unbind {
        width: 134px;
        height: 36px;
        background: #dedede;
        border-radius: 18px;
        font-size: 18px;
        color: #999999;
        text-align: center;
        line-height: 36px;
      }

      .btn_save {
        width: 134px;
        height: 36px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 18px;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
      }
    }
  }
}
</style>